import axios from "axios"
import { store } from "@/store/store"
import { Translate } from "@/utils/utils"
import { getCookie, delCookie } from "@/utils/cookie"

const TIMEOUT = 120000
const basePath = "Base/"
const vendorSitePath = "VendorSite/"

const Request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  header: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT,
})
const FileRequest = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  responseType: "blob",
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
  timeout: TIMEOUT,
})
const QRCodeRequest = axios.create({
  baseURL: process.env.VUE_APP_QRCODE_API_URL,
  header: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT,
})
Request.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Accept-Language"] = sessionStorage.getItem("Accept-Language")
    config.headers["TimeZone"] = new Date().toTimeString().slice(9, 17)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
Request.interceptors.response.use(
  (response) => {
    sessionStorage.removeItem("needUnauthorizeRedirect")
    return response
  },
  (error) => {
    const needUnauthorizeRedirect = sessionStorage.getItem("needUnauthorizeRedirect")
    if (error.response.status == 401 || error.response.status == 403) {
      delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
      if (needUnauthorizeRedirect === null && store.getters.isLogin) {
        let yes = confirm(` ${Translate("pages.wording.tokenIsExpiredPleaseReload")}`)
        if (yes) {
          sessionStorage.setItem("needUnauthorizeRedirect", "true")
          window.location.replace(location.protocol + "//" + location.host)
        }
      }
      store.dispatch("setLogin", false)
      window.location.replace(location.protocol + "//" + location.host)
    }else if(error.response.status == 400 || error.response.status == 500){
      console.error(error.response)
    }
    return Promise.reject(error)
  }
)
FileRequest.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
    config.headers["Accept-Language"] = sessionStorage.getItem("Accept-Language")
    config.headers["TimeZone"] = new Date().toTimeString().slice(9, 17)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
QRCodeRequest.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = sessionStorage.getItem("Accept-Language")
    config.headers["TimeZone"] = new Date().toTimeString().slice(9, 17)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
/***************-GENERAL-***************/
export const getVendorLoginInfo = () =>   Request.post(`${vendorSitePath}GetVendorLoginInfo`)
export const loginVendor = function (data) {
  return Request.post(vendorSitePath + "VendorLogin", null, data)
}
export const updateVendorPw = function (data) {
  return Request.post(vendorSitePath + "UpdateVendorPassword", null, data)
}
export const mailService = function (data) {
  return Request.post(vendorSitePath + "UtilsSentMail", data)
}
export const getCodeCultures = function () {
  return Request.get(basePath + "GetCodeCultures")
}
export const getCodeListWithCulture = function (data) {
  return Request.post(basePath + "GetCodeListWithCulture", data)
}
export const getRegion = function (data) {
  return Request.post(basePath + "getregion", data)
}
export const getArea = function (data) {
  return Request.post(basePath + "GetArea", data)
}
export const getFactory = function (data) {
  return Request.post(basePath + "GetFactory", data)
}
export const getEnterReason = function () {
  return Request.get(basePath + "getEnterReason")
}
export const getRegionAreaByFactory = function (data) {
  return Request.post(basePath + "GetRegionAreaByFactory", null, data)
}
export const getCarColor = function () {
  return Request.get(basePath + "getcarcolor")
}
export const getCartype = function () {
  return Request.get(basePath + "getcartype")
}
/***************-VENDOR-***************/
export const getNoticeList = function () {
  return Request.get(vendorSitePath + "GetNoticeList")
}
export const getNoticeIsActive = function () {
  return Request.get(vendorSitePath + "VendorNoticeIsActive")
}
export const getVendorInfo = function (data) {
  return Request.post(vendorSitePath + "GetVendorInfo", null, data)
}
/***************-RESERVE-***************/
export const getReserveTable = function (data) {
  return Request.post(vendorSitePath + "GetReserveTable", data)
}
export const getReserveInfo = function (data) {
  return Request.post(vendorSitePath + "GetReserveInfo", null, data)
}
export const updateReserveInfo = function (data) {
  return Request.post(vendorSitePath + "UpdataReserveByVendor", data)
}

export const getReserveTableCountForVendor = function (data) {
  return Request.post(vendorSitePath + "GetReserveTableCountForVendor", data)
}

export const getReserveTableCountForVendorSearch = function (data) {
  return Request.post(vendorSitePath + "GetReserveTableCountForVendorSearch", data)
}

export const getReserveTableForVendor = function (data) {
  return Request.post(vendorSitePath + "GetReserveTableForVendor", data)
}

export const exportReserveTableForVendor = function (data) {
  return FileRequest.post(vendorSitePath + "ExportReserveTableForVendor", data)
}

export const getVendorReleaseTable = function (data) {
  return Request.post(vendorSitePath + "GetVendorReleaseTable", data)
}

export const getReleaseInfo = function (releaseID) {
  return Request.get(vendorSitePath + `GetReleaseInfo?ReleaseID=${releaseID}`)
}

export const getSignTable = function (data) {
  return Request.post(vendorSitePath + "GetSignTable", data)
}

export const getSoListBindingWithReserveData = function (reserveID, oaCode) {
  return Request.get(vendorSitePath + `GetSoListBindingWithReserveData?ReserveID=${reserveID}&OACode=${oaCode}`)
}

export const getReleaseTableWithSign = function (data) {
  return Request.post(vendorSitePath + "GetReleaseTableWithSign", data)
}

export const getCompanyNameByPlantCode = function (data) {
  return Request.post(vendorSitePath + "GetCompanyNameByPlantCode", null, data)
}

export const hasAgreedPrivacy = function () {
  return Request.get(vendorSitePath + `HasAgreedPrivacy`)
}

export const updateAgreePrivacy = function () {
  return Request.put(vendorSitePath + `UpdateAgreePrivacy`)
}

export const getReserveQRCode = function (reserveNo, id) {
  return QRCodeRequest.get(`/reservation/${reserveNo}/${id}`)
}
